import { useFeatureFlagsStore } from '@/stores/featureFlags'

export default defineNuxtPlugin(async (nuxtApp) => {
  const featureFlagsStore = useFeatureFlagsStore()

  if (!featureFlagsStore.isFetched) {
    await featureFlagsStore.fetchFeatureFlags()
  }

  const isEnabled = ({ name = '' }) => {
    const store = useFeatureFlagsStore()
    if (!store.flags || !store.flags.toggles) {
      return false
    }

    return store.flags.toggles.some((f) => f.name === name && f.enabled)
  }

  nuxtApp.provide('flags', { isEnabled })
})
